import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Button,
    Icon,
    Row,
    Form,
    Input,
    Col
} from 'antd';

const css = require('./index.scss');
const FormItem= Form.Item;
const TextArea = Input.TextArea;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { editDescription, companyInfo } = this.modulesState;
        return (
            <div className={`${css['company-contariner']}`}>
                <header>
                    <h2>公司描述</h2>
                    {
                        editDescription ? (
                            <div className={css['company-contariner-hander']}>
                                <Button
                                    onClick={
                                        () => {
                                            this.updateDetailStatu(false);
                                        }
                                    }
                                >取消
                                </Button>
                                <Button 
                                    type="primary"
                                    onClick={
                                        () => {
                                            this.updateDescription();
                                        }
                                    }
                                >保存
                                </Button>
                            </div>
                        ) : (
                            <Icon 
                                type="edit"
                                onClick={
                                    () => {
                                        this.updateDetailStatu(true);
                                    }
                                }
                            />
                        )
                    }
                </header>
                <Form layout="vertical" className={css['company-contariner-form']}>
                    <Row type="flex" justify="space-between">
                        <Col span={24}>
                            <FormItem>
                                {
                                    editDescription ? (
                                        getFieldDecorator('description', {
                                            initialValue: companyInfo && companyInfo.description,
                                            rules: [
                                                {
                                                    max: 200, message: '基本信息不能超过200个字'
                                                }
                                            ]
                                        })
                                        (
                                            <TextArea
                                                placeholder="在我们的网络中介绍一下您的公司，以吸引更多的商业机会"
                                                style={{padding: '18px 12px'}}
                                                rows={5}
                                                onChange={this.changeDescription}
                                            />
                                        )
                                    ) : (<span>{companyInfo && companyInfo.description}</span>)
                                }
                                {
                                    editDescription && <span style={{float: 'right'}}>共{this.modulesState.description.length}/200</span>
                                }
                            </FormItem>                            
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }

    private updateDetailStatu = (b) => {
        ModulesAction.updateEditStatu('editDescription', b);
        if(this.modulesState.companyInfo.description === null) {
            ModulesAction.updateDescription('');
        } else {
            ModulesAction.updateDescription(this.modulesState.companyInfo.description);
        }
    }

    private updateDescription = () => {
        this.props.form.validateFields((err, val)=>{
            if (!err) {
                ModulesAction.descriptionUpdate(val);
                this.updateDetailStatu(false);
            }
        });
    }

    private changeDescription = e => {
        ModulesAction.updateDescription(e.target.value);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.Description.tsx